// extracted by mini-css-extract-plugin
export default {"container":"ContentTitle_container__bgWF4","title":"ContentTitle_title__UFozY","count":"ContentTitle_count__QhJZY"};